<template>
  <Selector
    :selected-option="selectedOption"
    label="filter-prop"
    :options="options"
    @select="$emit('select-filter-option', $event)"
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { keys, map } from 'ramda';
import { LabelledValue } from '@/types';
import { FilterOptions } from '@/filter/types';

import Selector from './Selector.vue';

type Option = LabelledValue<string>;

export default defineComponent({
  name: 'FilterSelector',

  components: {
    Selector,
  },

  props: {
    filterName: {
      type: String,
      required: true,
    },

    filterOptions: {
      type: Object as PropType<FilterOptions>,
      required: true,
    },
  },
  emits: { 'select-filter-option': null },

  computed: {
    selectedOption(): Option {
      return this.presentableFilter(this.filterName);
    },

    options(): Array<Option> {
      return map(this.presentableFilter, keys(this.filterOptions));
    },
  },

  methods: {
    presentableFilter(filterName): Option {
      return { value: filterName, label: this.$t(`filter.filters.${filterName}.label`) };
    },
  },
});
</script>
